import { referenceForwardArgs, sizeConst } from '@klarna/designtokens';
export var defaultSpaceTokens = {
  'space/0': sizeConst(0),
  'space/none': referenceForwardArgs('space/0'),
  'space/50': sizeConst(4),
  'space/100': sizeConst(8),
  'space/unit': referenceForwardArgs('space/100'),
  'space/150': sizeConst(12),
  'space/200': sizeConst(16),
  'space/300': sizeConst(24),
  'space/400': sizeConst(32),
  'space/500': sizeConst(40),
  'space/600': sizeConst(48),
  'space/800': sizeConst(64),
  'space/1000': sizeConst(80),
  'space/1200': sizeConst(96),
  'space/2000': sizeConst(160),
  /**
   * @deprecated v7.0.0
   * @useInstead space/0
   */
  'space.0': referenceForwardArgs('space/0', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/0'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/none
   */
  'space.none': referenceForwardArgs('space/none', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/none'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/50
   */
  'space.50': referenceForwardArgs('space/50', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/50'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/100
   */
  'space.100': referenceForwardArgs('space/100', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/100'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/unit
   */
  'space.unit': referenceForwardArgs('space/unit', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/unit'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/150
   */
  'space.150': referenceForwardArgs('space/150', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/150'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/200
   */
  'space.200': referenceForwardArgs('space/200', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/200'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/300
   */
  'space.300': referenceForwardArgs('space/300', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/300'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/400
   */
  'space.400': referenceForwardArgs('space/400', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/400'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/500
   */
  'space.500': referenceForwardArgs('space/500', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/500'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/600
   */
  'space.600': referenceForwardArgs('space/600', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/600'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/800
   */
  'space.800': referenceForwardArgs('space/800', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/800'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/1000
   */
  'space.1000': referenceForwardArgs('space/1000', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/1000'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/1200
   */
  'space.1200': referenceForwardArgs('space/1200', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/1200'
    }
  }),
  /**
   * @deprecated v7.0.0
   * @useInstead space/2000
   */
  'space.2000': referenceForwardArgs('space/2000', {
    deprecation: {
      removalDate: 'v7.0.0',
      useInstead: 'space/2000'
    }
  })
};
//# sourceMappingURL=index.js.map